import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, shallowEqual, useSelector } from 'react-redux';
import cn from 'classnames';
import { createSelector } from 'reselect';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Redirect, Route, Switch } from 'react-router-dom';
import { initEnvironment } from 'actions/environment';
import styles from './App.scss';
import { withRouter } from 'react-router-dom';

import ReactTooltip from 'react-tooltip';

import Header from 'components/Header';
import Buildings from 'components/Buildings';
import Cotteges from 'components/Cotteges';
import Favorites from 'components/Favorites';
import Collections from 'components/Collections';
import Collection from 'components/Collection';
import ClientMap from 'components/ClientMap';
import ClientCollection from 'components/ClientCollection';
import Profile from 'components/Profile';
import Company from 'components/Profile/Company';
import ClientBuilding from '../ClientBuilding';
import PrintBuilding from '../PrintBuilding';
import Building from '../Building';
import Logout from '../Logout';
import Login from '../Login/Login2';
import PopUp from '../PopUp';
import FailPage from 'components/Payments/FailPage';
import SuccessPage from 'components/Payments/SuccessPage';
import PaymentsNotification from 'components/Payments/Notification';
import Notification from 'components/Notification';
import ObserveErrors from 'components/ObserveErrors';

import PublicOffer from '../PublicOffer';
import Politika from '../Politika';
import Soglashenie from '../Soglashenie';

import { getCities } from '../../actions/building';
import Support from '../../components/Support';
import Rates from '../Rates';
import { WebaskProvider } from '../Webask/WebaskProvider';
import { trackPageview } from '../../services/ga';
import { getBanner } from '../../actions/banner';
import PrivacyPolicy from '../Landing/PrivacyPolicy';
import UserAgreement from '../Landing/UserAgreement';
import CookieBanner from '../../components/CookieBanner';
import PersonalData from '../Landing/PersonalData';
import AboutProject from '../Landing/AboutProject';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  popUp: PropTypes.object,
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 0,
    },
  },
});

const authenticatedSelector = (state) => state.authentication.authenticated;

const NedvexRoute = ({ component, requireAuth = false, ...rest }) => {
  const authenticated = useSelector((state) => state.authentication.authenticated, shallowEqual);
  const Component = component;

  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (requireAuth && !authenticated) {
          return <Redirect to="/login" />;
        }

        if (!requireAuth && authenticated) {
          return <Redirect to="/" />;
        }

        return <Component {...matchProps} />;
      }}
    />
  );
};

class App extends Component {
  componentDidMount() {
    const { dispatch, location } = this.props;
    trackPageview(window.location.pathname + window.location.search);
    dispatch(initEnvironment());

    if (location.pathname !== '/login') {
      dispatch(getCities());
    }

    dispatch(getBanner());
  }

  componentDidUpdate(prevProps) {
    const { dispatch, location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      trackPageview(location.pathname + location.search);

      if (location.pathname !== '/login' && prevProps.location.pathname === '/login') {
        dispatch(getCities());
      }
    }
  }

  render() {
    // TODO: Нужно бы List и Map подключать напрямую, не через Buildings
    const { dispatch, popUp, popUpProps, authenticated, profile } = this.props;

    return (
      <QueryClientProvider client={queryClient}>
        <WebaskProvider profile={profile}>
          <div
            className={cn(styles.Sticky, {
              [styles.hasHeader]: authenticated && !location.href.includes('/rates'),
            })}
          >
            <Notification />
            <div className={styles.StickyInner}>
              <ObserveErrors />
              <Switch>
                <Route path="/collection/view/:referal" component={ClientCollection} />
                <Route path="/view/:referal/building/:id" component={ClientBuilding} />
                <Route path="/bref/:referal" component={ClientBuilding} />

                <Route path="/ncollection/:base64/:id" component={ClientBuilding} />
                <Route path="/ncollection/:base64" component={ClientCollection} />
                <Route path="/nbref/:base64" component={ClientBuilding} />

                <Route path="/eula" component={UserAgreement} />
                <Route path="/policy" component={PrivacyPolicy} />
                <Route path="/consent" component={PersonalData} />
                <Route path="/about" component={AboutProject} />

                <Route path="/rates" component={Rates} />

                <div className={styles.StickyInnerInner}>
                  <NedvexRoute requireAuth path="/" component={Header} />
                  <NedvexRoute requireAuth path="/profile" component={Profile} />
                  <NedvexRoute requireAuth path="/company" component={Company} />
                  <NedvexRoute requireAuth path="/" exact component={Buildings} />
                  <NedvexRoute requireAuth path="/collections" component={Collections} />
                  <NedvexRoute requireAuth path="/favorites" component={Favorites} />
                  <NedvexRoute
                    requireAuth
                    path="/collection/manage/:referal"
                    component={Collection}
                  />
                  <NedvexRoute requireAuth path="/print/:id" component={PrintBuilding} />
                  <NedvexRoute requireAuth path="/building/:id" component={Building} />
                  <NedvexRoute requireAuth path="/logout" component={Logout} />
                  <NedvexRoute requireAuth={false} path="/login" component={Login} />
                  <NedvexRoute requireAuth={false} path="/common" component={Login} />
                  <NedvexRoute requireAuth path="/cottages" component={Cotteges} />
                  <NedvexRoute requireAuth path="/pay/success" component={SuccessPage} />
                  <NedvexRoute requireAuth path="/pay/fail" component={FailPage} />
                  <NedvexRoute requireAuth path="/oferta" component={PublicOffer} />
                  <NedvexRoute requireAuth path="/politika" component={Politika} />
                  <NedvexRoute requireAuth path="/soglashenie" component={Soglashenie} />
                </div>
              </Switch>
            </div>
            <div>
              <ReactTooltip
                class={styles.Tooltip}
                id="global"
                effect="solid"
                place="bottom"
                type="dark"
                delayShow={300}
              />
            </div>
            <Support />
            <PaymentsNotification />
          </div>
          {popUp ? <PopUp content={popUp} dispatch={dispatch} {...popUpProps} /> : null}
          <CookieBanner />
        </WebaskProvider>
      </QueryClientProvider>
    );
  }
}

App.propTypes = propTypes;

const appSelector = createSelector(
  authenticatedSelector,
  (state) => state.environment.popUp,
  (state) => state.environment.popUpProps,
  (state) => state.search.request,
  (state) => state.profile,
  (authenticated, popUp, popUpProps, request, profile) => ({
    popUp,
    popUpProps,
    authenticated,
    request,
    profile,
  })
);

export default connect(appSelector)(withRouter(App));



// WEBPACK FOOTER //
// ./src/containers/App/App.js